import React from 'react';

const About = () => {
    return (
        <section className="py-5">
            <div className="container text-center">
                <img src="/img/logo.jpg" alt="Amanda Calem" className="rounded-circle mb-4" style={{ width: '150px', height: '150px' }} />
                <h2 className="mb-4">Sobre Amanda</h2>
                <p className="text-muted">
                    Amanda Calem es una apasionada educadora que fomenta el uso de herramientas de aprendizaje que inspiran
                    las emociones, la imaginación y fomentan el amor por la lectura.
                </p>
            </div>
        </section>
    );
};

export default About;